module.exports = __webpack_public_path__ + "img/temel-01.c8b6d320.svg";